import { Injectable } from '@angular/core';
import { ApiService } from '../api/api.service';
import { Observable } from 'rxjs';
import { ApiGetInterface, ApiPatchInterface } from '@core/models/apiServiceInterface.interface';
import { TermsOfService } from '@core/models/terms-of-service.interface';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TermsOfServiceService {

  constructor(
    private apiService: ApiService,
    private _http: HttpClient,
  ) { }

  public getLatestTermsVersionApi(namespaceId: string): Observable<TermsOfService>{
    const payload: ApiGetInterface = {
      url: `admin/terms-of-service/latest/${namespaceId}`
    }
    return this.apiService.get(payload);
  }

  public downloadTermsOfServiceApi(url: string): Observable<HttpResponse<Blob>> {
    const headersConfig = {
      'Without-Auth': 'true',
      Accept: "*/*",
    };
    const headers = new HttpHeaders(headersConfig);
    return this._http.get(url, {responseType: 'blob', observe: 'response', headers});
  }

  public updateUserTermsVersionApi(termsOfServiceVersion: string) {
    const payload: ApiPatchInterface = {
      url: `admin/users/terms-of-service/${termsOfServiceVersion}`
    }
    return this.apiService.put(payload);
  }

  getTermsData(url: string): Observable<string> {
    const headersConfig = {
      'Without-Auth': 'true',
      Accept: 'text/html',
    };
    const headers = new HttpHeaders(headersConfig);
  
    return this._http.get(url, { responseType: 'text', headers });
  }
}
